import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/shared/PageTitle';
import DashboardStats from '../../components/dashboard/DashboardStats';
import QuickActions from '../../components/dashboard/QuickActions';
import DashboardTabs from '../../components/dashboard/DashboardTabs';
import DashboardAnalytics from '../../components/dashboard/DashboardAnalytics';
import ProspectsKanban from '../../components/prospects/ProspectsKanban';
import PromotersKanban from '../../components/promoters/PromotersKanban';
import PromotersStats from '../../components/promoters/PromotersStats';
import { useGetDashboardStatsQuery } from '../../store/vendorApi';

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'overview' | 'prospects' | 'promoters'>('overview');
  const { data: dashboardStats, isLoading: dashboardLoading } = useGetDashboardStatsQuery();

  const renderTabContent = () => {
    switch (activeTab) {
      case 'prospects':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm">
              <div className="p-6 border-b">
                <h2 className="text-lg font-semibold">{t('dashboard.prospectsKanban')}</h2>
              </div>
              <div className="p-6">
                <ProspectsKanban />
              </div>
            </div>
          </div>
        );

      case 'promoters':
        return (
          <div className="space-y-6">
            <PromotersStats />
            <div className="bg-white rounded-xl shadow-sm">
              <div className="p-6 border-b">
                <h2 className="text-lg font-semibold">{t('dashboard.promotersKanban')}</h2>
              </div>
              <div className="p-6">
                <PromotersKanban />
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="space-y-6">
            <DashboardStats stats={dashboardStats} loading={dashboardLoading} />
            <QuickActions />
            <DashboardAnalytics stats={dashboardStats} loading={dashboardLoading} />
          </div>
        );
    }
  };

  return (
    <div className="space-y-6">
      <PageTitle title={t('dashboard.title')} />
      {/* Header avec onglets */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">{t('dashboard.title')}</h1>
        <DashboardTabs activeTab={activeTab} onTabChange={setActiveTab} />
      </div>

      {/* Contenu selon l'onglet actif */}
      {renderTabContent()}
    </div>
  );
};

export default Dashboard;